/**
 * Product compare table
 * Listens to swatch clicks to toggle variant image display
 */
if (!customElements.get("compare-table")) {
  customElements.define(
    "compare-table",
    class CompareTable extends HTMLElement {
      constructor() {
        super();

        this.initSwatchListeners();

        if (!webvista.isMobileScreen()) {
          this.initZebra();
        }

        // Design mode or debug mode
        if (window.Shopify.designMode || window.debug) {
          this.unwatchDesktopEnter = webvista.watchDesktopEnter(() => {
            this.initZebra();
          });
        }
      }

      disconnectedCallback() {
        this.destroySwatchListeners();

        if (window.Shopify.designMode || window.debug) {
          if (this.unwatchDesktopEnter) this.unwatchDesktopEnter();
        }
      }

      /**
       * Initialize zebra striping for alternate row backgrounds
       */
      initZebra() {
        this.querySelectorAll(".table-row").forEach((row, idx) => {
          if ((idx + 1) % 2 === 0) {
            row.classList.add("zebra-row");
          }
        });
      }

      /**
       * Listen for swatch clicks within elements that have data-swatch-synergy attribute
       */
      initSwatchListeners() {
        this.boundOnSwatchesClick = this.onSwatchesClick.bind(this);
        this.swatchElements = this.querySelectorAll(
          "[data-swatch-synergy] .color-swatches",
        );

        this.swatchElements.forEach((swatches) => {
          swatches.addEventListener("click", this.boundOnSwatchesClick);
        });
      }

      /**
       * Remove swatch event listeners
       */
      destroySwatchListeners() {
        if (!this.swatchElements || !this.boundOnSwatchesClick) return;

        this.swatchElements.forEach((swatches) => {
          swatches.removeEventListener("click", this.boundOnSwatchesClick);
        });
      }

      onSwatchesClick(event) {
        event.preventDefault();
        event.stopPropagation();

        const swatch = event.target.closest(".color-swatch");
        if (!swatch) return;

        const index = swatch.getAttribute("data-index");
        const column = swatch.closest("td").dataset.id;

        const currentSwatch = event.currentTarget.querySelector(
          ".color-swatch.active",
        );
        if (currentSwatch) this.toggleSwatch(currentSwatch, column, false);
        if (swatch !== currentSwatch) this.toggleSwatch(swatch, column);
      }

      /**
       * Toggle swatch active state and show/hide variant image
       * @param {Element} swatch - The swatch element
       * @param {string} column - The column identifier
       * @param {boolean} active - Whether to activate or deactivate
       */
      toggleSwatch(swatch, column, active = true) {
        const variantImage = this.querySelector(
          `.product-variant-image[data-index='${column}-${swatch.dataset.index}']`,
        );
        if (!variantImage) return;

        if (active) {
          swatch.classList.add("active");
          variantImage.classList.remove("hidden");
          variantImage.parentElement.classList.add("has-swatch-active");
        } else {
          swatch.classList.remove("active");
          variantImage.classList.add("hidden");
          variantImage.parentElement.classList.remove("has-swatch-active");
        }
      }
    },
  );
}
